import { createUser } from "@/api/api";
import { useRequest } from "ahooks";

const useCreateUser = () => {
    const {run: fetchCreateUser, loading: createUserLoading} = useRequest(createUser,{
        manual: true,
        onSuccess: () => {}
    })
    return {fetchCreateUser, createUserLoading};
}
 
export default useCreateUser;